export default __webpack_public_path__ + "static/media/Background_00187.73aea108.png";